import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
interface DemographicData {
  ageGroup: string;
  male: number;
  female: number;
}
interface DemographicPyramidProps {
  data: DemographicData[];
}
export const DemographicPyramid: React.FC<DemographicPyramidProps> = ({
  data
}) => {
  // Transform data for the pyramid chart
  const transformedData = data.map(item => ({
    ...item,
    male: -item.male // Make male values negative for left side of pyramid
  }));
  // Custom tooltip to show absolute values
  const CustomTooltip = ({
    active,
    payload,
    label
  }: any) => {
    if (active && payload && payload.length) {
      return <div className="bg-white p-2 border border-gray-300 shadow-sm rounded-md" data-id="element-169">
          <p className="font-semibold" data-id="element-170">{label}</p>
          {payload.map((entry: any, index: number) => <p key={index} style={{
          color: entry.color
        }} data-id="element-171">
              {entry.name}: {Math.abs(entry.value).toLocaleString()}
            </p>)}
        </div>;
    }
    return null;
  };
  return <ResponsiveContainer width="100%" height={400} data-id="element-172">
      <BarChart data={transformedData} layout="vertical" margin={{
      top: 20,
      right: 30,
      left: 30,
      bottom: 5
    }} data-id="element-173">
        <CartesianGrid strokeDasharray="3 3" data-id="element-174" />
        <XAxis type="number" tickFormatter={value => Math.abs(value).toString()} data-id="element-175" />
        <YAxis type="category" dataKey="ageGroup" width={80} data-id="element-176" />
        <Tooltip content={<CustomTooltip data-id="element-178" />} data-id="element-177" />
        <Legend data-id="element-179" />
        <Bar dataKey="male" name="Male" fill="#3b82f6" data-id="element-180" />
        <Bar dataKey="female" name="Female" fill="#ec4899" data-id="element-181" />
      </BarChart>
    </ResponsiveContainer>;
};